<template>
  <div id="app" class="p-4">
    <!-- Botón de micrófono para dictado por voz -->
    <div class="flex justify-end mb-2">
      <button
        type="button"
        @click="iniciarDictado"
        :disabled="escuchando"
        class="bg-gray-700 hover:bg-orange-500 text-white rounded-full p-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-7 h-7"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 18.75v1.5m0 0h3.75m-3.75 0H8.25m3.75-1.5a6 6 0 0 0 6-6V9a6 6 0 1 0-12 0v3a6 6 0 0 0 6 6Z"
          />
        </svg>
        <span v-if="escuchando" class="ml-2 animate-pulse text-orange-400"
          >Escuchando...</span
        >
      </button>
    </div>
    <form
      @submit.prevent="enviarFormulario"
      class="max-w-lg mx-auto bg-gray-800 p-6 rounded-lg shadow-lg"
    >
      <!-- <InputComponent
      label="nombre"
      id="nombre"
      v-model="presupuesto.cliente.nombre"
      placeholder="Escribe tu nombre"
    /> -->

      <h2 class="text-2xl font-semibold text-orange-500 mb-4">
        Informacion general
      </h2>

      <div class="mb-4">
        <label class="block text-lg text-gray-300">Cliente</label>
        <input
          v-model="presupuesto.cliente.nombre"
          type="text"
          placeholder="Nombre del cliente o institucion"
          @input="buscarSugerenciasClientes"
          @blur="ocultarSugerenciasClientesConRetraso"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias de clientes -->
        <ul
          v-if="mostrarSugerenciasClientes"
          class="sugerencias mt-2 list-none p-0 bg-white text-gray-800 border border-gray-300 rounded-md shadow-lg"
        >
          <li
            v-for="sugerencia in sugerenciasClientes"
            :key="sugerencia.Nombre"
            @click="seleccionarSugerenciaClientes(sugerencia)"
            class="px-4 py-2 cursor-pointer hover:bg-orange-200"
          >
            {{ sugerencia.Nombre + ` (${sugerencia.Comentarios}) ` }}
          </li>
        </ul>
      </div>
      <div
        class="flex items-center space-x-2 cursor-pointer"
        @click="toggleAjuste"
      >
        <h2 class="text-2xl font-semibold text-orange-500 mb-4">
          Descuento/Recargo
        </h2>
        <svg
          v-if="!mostrarAjuste"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6"
        >
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
            clip-rule="evenodd"
          />
        </svg>

        <svg
          v-if="mostrarAjuste"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6"
        >
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
            clip-rule="evenodd"
          />
        </svg>
      </div>

      <!-- Contenido del acordeón -->
      <div v-if="mostrarAjuste" class="mb-4">
        <div class="mb-4">
          <label class="block text-lg text-gray-300">Tipo</label>
          <select
            v-model="presupuesto.adicional.tipoAjuste"
            class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          >
            <option value="0">Descuento</option>
            <option value="1">Recargo</option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-lg text-gray-300">Modo</label>
          <select
            v-model="presupuesto.adicional.modoAjuste"
            class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          >
            <option value="0">Porcentaje</option>
            <option value="1">Monto Fijo</option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-lg text-gray-300">Valor</label>
          <input
            v-model.number="presupuesto.adicional.valorAjuste"
            type="number"
            placeholder="Ingrese el valor del ajuste"
            class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          />
        </div>
      </div>
    </form>
    <!-- Formulario para agregar productos y generar presupuesto -->
    <form
      @submit.prevent="enviarFormulario"
      class="max-w-lg mt-8 mx-auto bg-gray-800 p-6 rounded-lg shadow-lg"
    >
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">
        Agregar Producto
      </h2>
      <div class="mb-4">
        <label class="block text-lg text-gray-300">Nombre del Producto</label>
        <input
          v-model="nuevoProducto.nombre"
          type="text"
          placeholder="Nombre del producto"
          @input="buscarSugerenciasProductos"
          @blur="ocultarSugerenciasProductosConRetraso"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias -->
        <ul
          v-if="mostrarSugerencias"
          class="sugerencias mt-2 list-none p-0 bg-white text-gray-800 border border-gray-300 rounded-md shadow-lg"
        >
          <li
            v-for="sugerencia in sugerencias"
            :key="sugerencia.nombre"
            @click="seleccionarSugerenciaProductos(sugerencia)"
            class="px-4 py-2 cursor-pointer hover:bg-orange-200"
          >
            {{ sugerencia.nombre }} - ${{ sugerencia.precio }}
          </li>
        </ul>
      </div>
      <div class="mb-4">
        <label class="block text-lg text-gray-300">Precio</label>
        <input
          v-model.number="nuevoProducto.precio"
          type="number"
          placeholder="Precio del producto"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
      </div>
      <div class="mb-6">
        <label class="block text-lg text-gray-300">Cantidad</label>
        <input
          v-model.number="nuevoProducto.cantidad"
          type="number"
          placeholder="Cantidad"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
      </div>
      <button
        type="button"
        @click="agregarProducto"
        class="w-full py-3 text-lg text-white bg-blue-500 rounded-md hover:bg-blue-600"
      >
        Agregar Producto
      </button>
    </form>

    <form
      @submit.prevent="enviarFormulario"
      class="max-w-lg mt-8 mx-auto bg-gray-800 p-6 rounded-lg shadow-lg"
    >
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">Observaciones</h2>
      <div class="mb-4">
        <textarea
          v-model="presupuesto.observaciones"
          placeholder="Observaciones"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          rows="4"
        ></textarea>

        <!-- Sugerencias -->
      </div>
    </form>

    <!-- Lista de productos agregados -->
    <div class="mt-8 max-w-lg mx-auto bg-gray-800 p-6 rounded-lg shadow-lg">
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">Resumen</h2>
      <ul>
        <li
          v-for="(producto, index) in presupuesto.productos"
          :key="index"
          class="mb-4 p-4 bg-gray-700 rounded-md border border-gray-600 flex justify-between items-center"
        >
          <div>
            <p class="text-white">
              <strong>nombre:</strong> {{ producto.nombre }}
            </p>
            <p class="text-gray-400">
              <strong>Precio:</strong> ${{ producto.precio }}
            </p>
            <p class="text-gray-400">
              <strong>Cantidad:</strong> {{ producto.cantidad }}
            </p>
          </div>
          <button
            @click="eliminarProducto(index)"
            class="py-2 px-4 text-white bg-red-500 rounded-md hover:bg-red-600"
          >
            Eliminar
          </button>
        </li>
      </ul>
      <p v-if="presupuesto.productos.length > 0" class="text-white text-lg">
        {{
          calcularTotal().subtotal == calcularTotal().total
            ? ""
            : `Subtotal: $${calcularTotal().subtotal}`
        }}
      </p>
      <p v-if="presupuesto.productos.length > 0" class="text-white text-lg">
        {{
          calcularTotal().ajuste === 0
            ? ""
            : calcularTotal().ajuste > 0
            ? `Recargo: $${calcularTotal().ajuste}`
            : `Descuento: $${Math.abs(calcularTotal().ajuste)}`
        }}
      </p>
      <p v-if="presupuesto.productos.length > 0" class="text-white text-lg">
        Total: ${{ calcularTotal().total }}
      </p>
    </div>

    <!-- Botón para generar presupuesto -->
    <div class="mt-6 max-w-lg mx-auto">
      <button
        @click="enviarFormulario"
        class="w-full py-3 text-lg text-white bg-green-500 rounded-md hover:bg-green-600"
      >
        {{ presupuesto.uuid ? "Editar Presupuesto" : "Generar Presupuesto" }}
      </button>
    </div>
  </div>
</template>

<script>
import PresupuestosProvider from "@/helpers/providers/PresupuestosProvider";
import ProductsProvider from "@/helpers/providers/ProductsProvider";
import ClientesProvider from "@/helpers/providers/ClientesProvider";
// import InputComponent from "@/components/InputComponent.vue";

export default {
  components: {
    // InputComponent,
  },
  data() {
    return {
      escuchando: false,
      textoDictado: "",
      mostrarAjuste: false,
      presupuesto: {
        uuid: null,
        cliente: { ID_CLIENTE: 0, nombre: "" },
        productos: [],
        adicional: {
          tipoAjuste: 0, // "descuento" o "recargo"
          modoAjuste: 0, // "porcentaje" o "monto"
          valorAjuste: 0,
        },
        observaciones: null,
      },
      nuevoProducto: {
        nombre: "",
        precio: 0,
        cantidad: 1,
      },
      sugerencias: [],
      mostrarSugerencias: false,
      productosMemoria: [],
      clientesMemoria: [],
      sugerenciasClientes: [],
      mostrarSugerenciasClientes: false,
    };
  },

  methods: {
    async iniciarDictado() {
      if (
        !("webkitSpeechRecognition" in window) &&
        !("SpeechRecognition" in window)
      ) {
        this.$notiflix.Notify.failure(
          "El reconocimiento de voz no es compatible con este navegador."
        );
        return;
      }
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.lang = "es-ES";
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      this.escuchando = true;
      recognition.start();
      recognition.onresult = async (event) => {
        const texto = event.results[0][0].transcript;
        this.textoDictado = texto;
        this.escuchando = false;
        this.$notiflix.Notify.success("Dictado recibido: " + texto);
        await this.procesarTextoDictado(texto);
      };
      recognition.onerror = (event) => {
        this.escuchando = false;
        this.$notiflix.Notify.failure(
          "Error en el reconocimiento de voz: " + event.error
        );
      };
      recognition.onend = () => {
        this.escuchando = false;
      };
    },

    async procesarTextoDictado(texto) {
    
      this.$notiflix.Report.info("Texto dictado", texto, "Cerrar");
    },
    toggleAjuste() {
      this.mostrarAjuste = !this.mostrarAjuste; // Alterna la visibilidad del ajuste
    },

    calcularTotal() {
      const subtotal = this.presupuesto.productos.reduce(
        (sum, producto) => sum + producto.precio * producto.cantidad,
        0
      );

      let ajuste = 0;
      if (this.presupuesto.adicional.modoAjuste == 0) {
        ajuste = (subtotal * this.presupuesto.adicional.valorAjuste) / 100;
      } else {
        ajuste = this.presupuesto.adicional.valorAjuste;
      }

      if (this.presupuesto.adicional.tipoAjuste == 0) {
        ajuste = -ajuste;
      }

      let total = subtotal + ajuste;
      //let subtotal = 0;
      //let total = 0;
      //let ajuste = 0;

      return { subtotal, total, ajuste };
    },

    async cargarProductos() {
      try {
        this.productosMemoria = await ProductsProvider.getProductos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
    async cargarClientes() {
      try {
        this.clientesMemoria = await ClientesProvider.getClientes();
      } catch (error) {
        console.error("Error al cargar Clientes:", error);
      }
    },
    buscarSugerenciasProductos() {
      const query = this.nuevoProducto.nombre;
      if (query.length < 2) {
        this.sugerencias = [];
        this.mostrarSugerencias = false;
        return;
      }
      this.sugerencias = this.productosMemoria.filter((producto) =>
        producto.nombre.toLowerCase().includes(query.toLowerCase())
      );
      this.mostrarSugerencias = this.sugerencias.length > 0;
    },
    seleccionarSugerenciaProductos(producto) {
      this.nuevoProducto.nombre = producto.nombre;
      this.nuevoProducto.precio = producto.precio;
      this.mostrarSugerencias = false;
    },
    ocultarSugerenciasProductosConRetraso() {
      setTimeout(() => {
        this.mostrarSugerencias = false;
      }, 200);
    },
    buscarSugerenciasClientes() {
      const query = this.presupuesto.cliente.nombre;
      if (query.length < 2) {
        this.sugerenciasClientes = [];
        this.mostrarSugerenciasClientes = false;
        return;
      }
      this.sugerenciasClientes = this.clientesMemoria.filter((cliente) =>
        cliente.Nombre.toLowerCase().includes(query.toLowerCase())
      );
      // console.log(this.sugerenciasClientes)
      this.mostrarSugerenciasClientes = this.sugerenciasClientes.length > 0;
    },
    seleccionarSugerenciaClientes(cliente) {
      //console.log(cliente);
      this.presupuesto.cliente.nombre = cliente.Nombre;
      this.presupuesto.cliente.ID_CLIENTE = cliente.ID;
      this.mostrarSugerenciasClientes = false;
    },
    ocultarSugerenciasClientesConRetraso() {
      setTimeout(() => {
        this.mostrarSugerenciasClientes = false;
      }, 200);
    },
    agregarProducto() {
      if (
        this.nuevoProducto.nombre &&
        this.nuevoProducto.precio > 0 &&
        this.nuevoProducto.cantidad > 0
      ) {
        this.presupuesto.productos.push({ ...this.nuevoProducto });
        this.nuevoProducto = { nombre: "", precio: 0, cantidad: 1 };
      } else {
        this.$notiflix.Notify.failure(
          "Por favor, complete los campos correctamente."
        );
      }
    },
    eliminarProducto(index) {
      this.presupuesto.productos.splice(index, 1);
    },
    async enviarFormulario() {
      if (this.presupuesto.productos.length === 0) {
        this.$notiflix.Notify.failure(
          "Por favor, agregue al menos un producto."
        );
        return;
      }
      try {
        this.loading = true;
        this.$notiflix.Loading.standard();
        var uuid = null;
        if (this.presupuesto.uuid) {
          uuid = await PresupuestosProvider.updatePresupuesto(this.presupuesto);
        } else {
          uuid = await PresupuestosProvider.newPresupuesto(this.presupuesto);
        }

        this.$notiflix.Loading.remove();
        this.loading = false;
        this.$notiflix.Notify.success("Presupuesto registrado con éxito.");
        this.presupuesto = {
          cliente: { nombre: "" },
          productos: [],
          adicional: {
            tipoAjuste: 0,
            modoAjuste: 0,
            valorAjuste: 0,
          },
        };

        PresupuestosProvider.getPDF(uuid);
      } catch (error) {
        this.$notiflix.Report.failure(
          "Error al registrar presupuesto",
          "Compruebe los campos e intente nuevamente." + error,
          "Cerrar"
        );
      }
    },
  },
  async mounted() {
    if (this.$route.query.presupuesto != undefined) {
      //console.log(this.$route.query.presupuesto);
      //Aca logica de fetchear presupuesto y cargarlo en el formulario
      this.$notiflix.Loading.standard();
      var presupuesto = await PresupuestosProvider.getPresupuesto(
        this.$route.query.presupuesto
      );
      this.presupuesto.uuid = presupuesto.cabecera.UUID;
      this.presupuesto.cliente.nombre = presupuesto.cabecera.CLIENTE;
      if (presupuesto.observaciones != undefined) {
        this.presupuesto.observaciones = presupuesto.observaciones.Observacion;
      }
      // this.venta.productos = ;
      presupuesto.detalles.forEach((element) => {
        const producto = {
          nombre: element.Producto,
          precio: element.Precio,
          cantidad: element.Cantidad,
        };
        this.presupuesto.productos.push(producto);
      });
      if (presupuesto.adicional != undefined) {
        this.mostrarAjuste = true;
        this.presupuesto.adicional.tipoAjuste = presupuesto.adicional.Tipo;
        this.presupuesto.adicional.modoAjuste = presupuesto.adicional.Modo;
        this.presupuesto.adicional.valorAjuste = presupuesto.adicional.Valor;
      }
      this.$notiflix.Loading.remove();
    }
    this.cargarProductos();
    this.cargarClientes();
  },
};
</script>
